import { render, staticRenderFns } from "./RequiredFileManager.vue?vue&type=template&id=70ba4ebe&scoped=true&"
import script from "./RequiredFileManager.vue?vue&type=script&lang=js&"
export * from "./RequiredFileManager.vue?vue&type=script&lang=js&"
import style0 from "./RequiredFileManager.vue?vue&type=style&index=0&id=70ba4ebe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ba4ebe",
  null
  
)

export default component.exports